<template>
  <div class="content container-fluid">
    <!-- Popover for Filter -->
    <popover
      name="popName"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranName"
        :options="colFilter.tran_name_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popMerchant"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranMerchant"
        :options="colFilter.tran_merchant_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popStatus"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranStatus"
        :options="colFilter.tran_status_col_filter"
        :multiple="true"
      ></multiselect>
    </popover>
    <!-- /Popover for Filter -->

    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Flexible E-Coupons</h3>
        </div>
        <div
          class="col-auto float-right ml-auto"
          v-if="
            tokenObj.role == userRoleSuperAdmin ||
            tokenObj.role == userRoleAdmin
          "
        >
          <button class="btn add-btn" @click="showAddModal">
            <i class="fa fa-plus"></i>Add Coupon
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">No</th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popName
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranName.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('name')">
                    Name
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'name'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'name_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th
                  v-if="
                    tokenObj.role == userRoleSuperAdmin ||
                    tokenObj.role == userRoleAdmin
                  "
                >
                  <i
                    class="fa fa-filter"
                    v-popover:popMerchant
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranMerchant.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('merchant')">
                    Merchant
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'merchant'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'merchant_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('startDate')">
                    Start Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'startDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'startDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('expiryDate')">
                    Expiry Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'expiryDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'expiryDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('totalQuota')">
                    Total Quota
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'totalQuota'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'totalQuota_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('totalGenerated')">
                    Total Generated Codes
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'totalGenerated'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'totalGenerated_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('totalRedeemed')">
                    Total Redeemed Codes
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'totalRedeemed'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'totalRedeemed_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('createdDate')">
                    Created Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'createdDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'createdDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popStatus
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranStatus.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('status')">
                    Status
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'status'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'status_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody v-if="$store.state.isLoading">
              <tr>
                <td class="text-center" colspan="10">Loading ...</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(rec, i) in records" :key="i">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td>{{ rec.name }}</td>
                <td
                  v-if="
                    tokenObj.role == userRoleSuperAdmin ||
                    tokenObj.role == userRoleAdmin
                  "
                >
                  {{ rec.merchant_name }}
                </td>
                <td>{{ rec.start_date_display }}</td>
                <td>{{ rec.expiry_date_display }}</td>
                <td>
                  {{ !rec.total_quota ? "Unlimited" : rec.total_quota }}
                </td>
                <td>{{ rec.total_generated_codes }}</td>
                <td>{{ rec.total_redeemed_codes }}</td>
                <td>{{ rec.created_date_display }}</td>
                <td>
                  <span
                    class="badge badge-pill"
                    :class="{
                      'badge-success': rec.status == ecouponStatusActive,
                      'badge-danger': rec.status == ecouponStatusExpired,
                    }"
                  >
                    {{ rec.status }}
                  </span>
                </td>
                <td>
                  <button
                    class="btn btn-sm btn-primary"
                    @click="viewFlexibleEcouponDetail(rec.id)"
                  >
                    <i class="fa fa-file-alt mr-1"></i>View Generated Codes
                  </button>
                  <button
                    v-if="
                      (tokenObj.role == userRoleSuperAdmin ||
                        tokenObj.role == userRoleAdmin) &&
                      !rec.total_generated_codes
                    "
                    class="btn btn-sm btn-primary"
                    @click="edit(rec)"
                  >
                    <i class="fa fa-pencil mr-1"></i>Edit
                  </button>
                  <button
                    v-if="
                      (tokenObj.role == userRoleSuperAdmin ||
                        tokenObj.role == userRoleAdmin) &&
                      !rec.total_generated_codes
                    "
                    class="btn btn-sm btn-danger"
                    @click="remove(rec.id)"
                  >
                    <i class="fa fa-trash-o mr-1"></i>Delete
                  </button>
                </td>
              </tr>
              <tr v-if="records && !records.length">
                <td colspan="10" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="records && records.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          records.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />
          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->

    <!-- Add Flexible Ecoupon Modal -->
    <div class="modal custom-modal fade" id="addModal" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">Add Flexible E-Coupon</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <form @submit.prevent="add">
              <div class="form-group">
                <label>Name</label>
                <input
                  type="text"
                  v-model="formAdd.name"
                  class="form-control"
                  maxlength="200"
                  required
                />
              </div>
              <div class="form-group">
                <div class="form-row">
                  <div class="col-md-6">
                    <label>Start Date</label>
                    <input
                      type="date"
                      v-model="formAdd.startDate"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Expiry Date</label>
                    <input
                      type="date"
                      v-model="formAdd.expiryDate"
                      :min="formAdd.startDate"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="form-row">
                  <div class="col-md-6">
                    <label>Total Quota</label>
                    <input
                      type="number"
                      v-model="formAdd.totalQuota"
                      class="form-control"
                      min="1"
                      step="1"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>Merchant(s)</label>
                <multiselect
                  v-model="formAdd.merchantIds"
                  :options="merchants"
                  :multiple="true"
                  label="name"
                  track-by="id"
                ></multiselect>
              </div>
              <div class="submit-section mt-4">
                <button class="btn btn-primary submit-btn">Add</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Flexible Ecoupon Modal -->

    <!-- Edit Flexible Ecoupon Modal -->
    <div class="modal custom-modal fade" id="editModal" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">Edit Flexible E-Coupon</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <form @submit.prevent="update">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Merchant</label>
                  <h5>{{ formEdit.merchantName }}</h5>
                </div>
                <div class="form-group col-md-6">
                  <label>Created Date</label>
                  <h5>{{ formEdit.createdDateDisplay }}</h5>
                </div>
              </div>
              <div class="form-group">
                <label>Name</label>
                <input
                  type="text"
                  v-model="formEdit.name"
                  class="form-control"
                  maxlength="200"
                  required
                />
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Start Date</label>
                  <input
                    type="date"
                    v-model="formEdit.startDate"
                    class="form-control"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label>Expiry Date</label>
                  <input
                    type="date"
                    v-model="formEdit.expiryDate"
                    :min="formEdit.startDate"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Total Quota</label>
                  <input
                    type="number"
                    v-model="formEdit.totalQuota"
                    class="form-control"
                    min="1"
                    step="1"
                  />
                </div>
              </div>
              <div class="submit-section mt-4">
                <button class="btn btn-primary submit-btn">Update</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Flexible Ecoupon Modal -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Multiselect from "vue-multiselect";
import $ from "jquery";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      userRoleSuperAdmin: config.USER_ROLE_SUPER_ADMIN,
      userRoleAdmin: config.USER_ROLE_ADMIN,
      userRoleMerchantAdmin: config.USER_ROLE_MERCHANT_ADMIN,
      ecouponStatusActive: config.ECOUPON_STATUS_ACTIVE,
      ecouponStatusExpired: config.ECOUPON_STATUS_EXPIRED,
      records: [],
      //popup
      merchants: [],
      formAdd: {
        name: "",
        startDate: "",
        expiryDate: "",
        totalQuota: null,
        merchantIds: [],
      },
      formEdit: {
        name: "",
        id: "",
        merchantName: "",
        createdDateDisplay: "",
        startDate: "",
        expiryDate: "",
        totalQuota: null,
      },
      //pagination
      searchColFilter: {
        tranName: [],
        tranMerchant: [],
        tranStatus: [],
      },
      colFilter: {},
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
    searchFilter() {
      return [
        { name: "tranName", val: this.searchColFilter.tranName },
        { name: "tranMerchant", val: this.searchColFilter.tranMerchant },
        { name: "tranStatus", val: this.searchColFilter.tranStatus },
      ];
    },
  },
  watch: {
    "searchColFilter.tranName": function (val, oldVal) {
      this.getFlexibleEcouponList();
    },
    "searchColFilter.tranMerchant": function (val, oldVal) {
      this.getFlexibleEcouponList();
    },
    "searchColFilter.tranStatus": function (val, oldVal) {
      this.getFlexibleEcouponList();
    },
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getFlexibleEcouponList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    //popup
    showAddModal() {
      this.formAdd = {
        name: "",
        startDate: "",
        expiryDate: "",
        totalQuota: null,
        merchantIds: [],
      };
      $("#addModal").modal("show");
    },
    edit(payload) {
      this.formEdit.id = payload.id;
      this.formEdit.merchantName = payload.merchant_name;
      this.formEdit.createdDateDisplay = payload.created_date_display;
      this.formEdit.name = payload.name;
      this.formEdit.startDate = payload.start_date;
      this.formEdit.expiryDate = payload.expiry_date;
      this.formEdit.totalQuota = payload.total_quota;
      $("#editModal").modal("show");
    },
    getMerchants() {
      API.getActiveMerchants()
        .then((response) => {
          if (response.data.success) {
            this.merchants = response.data.records;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //main
    add() {
      if (!this.formAdd.merchantIds.length) {
        this.$swal("Please select at least 1 merchant", { icon: "error" });
        return;
      }
      let param = {
        name: this.formAdd.name,
        start_date: this.formAdd.startDate,
        expiry_date: this.formAdd.expiryDate,
        total_quota: this.formAdd.totalQuota,
        merchant_ids: this.formAdd.merchantIds.map((item) => item.id),
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to add the flexible e-coupon?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.addFlexibleEcoupon(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getFlexibleEcouponList();
                $("#addModal").modal("hide");
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
    update() {
      let param = {
        id: this.formEdit.id,
        name: this.formEdit.name,
        start_date: this.formEdit.startDate,
        expiry_date: this.formEdit.expiryDate,
        total_quota: this.formEdit.totalQuota,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to add the flexible e-coupon?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.updateFlexibleEcoupon(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getFlexibleEcouponList();
                $("#editModal").modal("hide");
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
    remove(id) {
      let param = { id: id };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the flexible e-coupon?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.deleteFlexibleEcoupon(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getFlexibleEcouponList();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
    getFlexibleEcouponList() {
      let param = {
        current_page: this.paging.CurrentPage,
        total_page: this.paging.TotalPage,
        size_per_page: this.paging.SizePerPage,
        sort_by: this.paging.SortBy,
        search_filter: this.searchFilter,
      };
      this.$store.state.isLoading = true;
      API.getFlexibleEcoupons(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.records = response.data.records;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.page_count;
            this.colFilter = response.data.col_filter;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    viewFlexibleEcouponDetail(id) {
      let routerName = "adminFlexibleEcouponDetail";
      if (this.tokenObj.role == this.userRoleMerchantAdmin) {
        routerName = "merchantFlexibleEcouponDetail";
      }
      this.$router.push({ name: routerName, params: { id: id } });
    },
    //pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getFlexibleEcouponList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getFlexibleEcouponList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getFlexibleEcouponList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getFlexibleEcouponList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getFlexibleEcouponList();
    },
    setSortBy(payload) {
      switch (payload) {
        case "name":
          if (this.paging.SortBy === "name") {
            this.paging.SortBy = "name_desc";
          } else if (this.paging.SortBy === "name_desc") {
            this.paging.SortBy = "name";
          } else {
            this.paging.SortBy = "name";
          }
          break;
        case "merchant":
          if (this.paging.SortBy === "merchant") {
            this.paging.SortBy = "merchant_desc";
          } else if (this.paging.SortBy === "merchant_desc") {
            this.paging.SortBy = "merchant";
          } else {
            this.paging.SortBy = "merchant";
          }
          break;
        case "startDate":
          if (this.paging.SortBy === "startDate") {
            this.paging.SortBy = "startDate_desc";
          } else if (this.paging.SortBy === "startDate_desc") {
            this.paging.SortBy = "startDate";
          } else {
            this.paging.SortBy = "startDate";
          }
          break;
        case "expiryDate":
          if (this.paging.SortBy === "expiryDate") {
            this.paging.SortBy = "expiryDate_desc";
          } else if (this.paging.SortBy === "expiryDate_desc") {
            this.paging.SortBy = "expiryDate";
          } else {
            this.paging.SortBy = "expiryDate";
          }
          break;
        case "totalQuota":
          if (this.paging.SortBy === "totalQuota") {
            this.paging.SortBy = "totalQuota_desc";
          } else if (this.paging.SortBy === "totalQuota_desc") {
            this.paging.SortBy = "totalQuota";
          } else {
            this.paging.SortBy = "totalQuota";
          }
          break;
        case "totalGenerated":
          if (this.paging.SortBy === "totalGenerated") {
            this.paging.SortBy = "totalGenerated_desc";
          } else if (this.paging.SortBy === "totalGenerated_desc") {
            this.paging.SortBy = "totalGenerated";
          } else {
            this.paging.SortBy = "totalGenerated";
          }
          break;
        case "totalRedeemed":
          if (this.paging.SortBy === "totalRedeemed") {
            this.paging.SortBy = "totalRedeemed_desc";
          } else if (this.paging.SortBy === "totalRedeemed_desc") {
            this.paging.SortBy = "totalRedeemed";
          } else {
            this.paging.SortBy = "totalRedeemed";
          }
          break;
        case "createdDate":
          if (this.paging.SortBy === "createdDate") {
            this.paging.SortBy = "createdDate_desc";
          } else if (this.paging.SortBy === "createdDate_desc") {
            this.paging.SortBy = "createdDate";
          } else {
            this.paging.SortBy = "createdDate";
          }
          break;
        case "status":
          if (this.paging.SortBy === "status") {
            this.paging.SortBy = "status_desc";
          } else if (this.paging.SortBy === "status_desc") {
            this.paging.SortBy = "status";
          } else {
            this.paging.SortBy = "status";
          }
          break;
      }
      this.getFlexibleEcouponList();
    },
  },
  created() {
    this.getMerchants();
    this.getFlexibleEcouponList();
  },
};
</script>

<style scoped>
.merchant-label,
input[type="checkbox"] {
  cursor: pointer;
}
.merchant-div {
  height: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/Share/FlexibleEcouponList.vue